/**
 * RESPONSIBILITY: the codes both sides compare against. Values only, no payload shapes.
 *
 * Every one of these is a string or number that crosses the wire and is then tested with
 * `===`. Defining them once is what stops a client checking for 'FORBIDDEN' while a
 * server sends 'Forbidden'.
 */

export enum SectionStatus {
  /** Your version is the latest. No payload returned. */
  Current = 'CURRENT',
  /** A newer version exists. Payload included. */
  Modified = 'MODIFIED',
  NotFound = 'NOT_FOUND',
  /** Exists, but you may not read it. */
  Forbidden = 'FORBIDDEN',
}

export enum WriteMode {
  Create = 'CREATE',
  Update = 'UPDATE',
  Delete = 'DELETE',
}

export enum RevType { Add = 'ADD', Mod = 'MOD', Del = 'DEL' }

export enum UserStatus {
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
}

/** How a browser-side failure was caught. The browser gives three distinct chances. */
export enum ClientErrorKind {
  /** window 'error' — a throw that reached the top. */
  Error = 'error',
  /** A rejected promise nobody handled. */
  Rejection = 'unhandledrejection',
  /** A React render threw and the boundary caught it. */
  Render = 'render',
}

export enum ApiError {
  Unauthenticated = 'UNAUTHENTICATED',
  Forbidden = 'FORBIDDEN',
  UnknownSection = 'UNKNOWN_SECTION',
  ValidationFailed = 'VALIDATION_FAILED',
  VersionConflict = 'VERSION_CONFLICT',
  AlreadyExists = 'ALREADY_EXISTS',
  CaptchaFailed = 'CAPTCHA_FAILED',
  Invalid = 'INVALID',
  InvalidCredentials = 'INVALID_CREDENTIALS',
  PendingApproval = 'PENDING_APPROVAL',
  Rejected = 'REJECTED',
  TooLarge = 'TOO_LARGE',
}

export const HTTP = {
  ok: 200,
  badRequest: 400,
  unauthenticated: 401,
  forbidden: 403,
  notFound: 404,
  conflict: 409,
  /** Version precondition failed — HTTP's precise code for a stale write. */
  preconditionFailed: 412,
  tooLarge: 413,
  unprocessable: 422,
  /** Only for genuinely unhandled failures. Expected refusals are return values. */
  serverError: 500,
} as const;
